var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScooter = function SvgScooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "12 15 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".scooter_svg__a_K3C4GLU5{fill:currentColor}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "scooter_svg__a_K3C4GLU5",
    d: "M29 17a2.006 2.006 0 0 0-2-2h-2a1 1 0 0 0 0 2h2v2.65L23.52 24H20v-4a1 1 0 0 0-1-1h-3a4 4 0 0 0-4 4v3h2a3 3 0 0 0 6 0h4.48L29 20.35V17ZM17 27a1 1 0 0 1-1-1h2a1 1 0 0 1-1 1Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "scooter_svg__a_K3C4GLU5",
    d: "M19 16h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2ZM29 23a3 3 0 1 0 0 5.999A3 3 0 0 0 29 23Zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: "#000"
  })));
};
export default SvgScooter;